<template>
	<li class="hw_stat__item">
		<div class="hw_stat__left">
      <div class="hw_stat__date">
        <span class="ico-calendar" uk-tooltip="Дата"></span> <span>{{ date }}</span>
      </div>
      <h4>{{ getHomeworkStatus() }}</h4>
    </div>

		<div class="hw_stat__wrap">
			<ul class="hw_stat__trains">
				<HwStatItem v-for="(item, key) in train" :key="key" :item="item" />
			</ul>
		</div>
	</li>
</template>

<script>
	import HwStatItem from "./HwStatItem";
  export default {
    name: "hw_stat",
	  components: {
      HwStatItem
	  },
    props: {
      train: '',
      date: ''
    },
		methods: {
			getHomeworkStatus() {
				let completed = this.train.filter(item => item.is_done)

				if (completed.length) {
					let qualities = completed.map(item => item.quality)

					console.log(qualities)
					let sum = qualities.reduce((sum, elem) => {
						return sum + elem;
					}, 0);

					let result = (sum / qualities.length).toFixed(2)

					if (result > 100) {
						result = 100
					}
					return 'Качество выполнения ' + result + '%'
				} else {
					return 'Нет выполненных заданий'
				}
				
			}
		}
  }
</script>